import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import Dialog from '../UI/Dialog';
import TextFields from '../UI/TextFiled';
import Breadcrumb from '../UI/Breadcrumb';
import InputTabs from '../UI/InputTabs';
import {addMenu, getMenu, editMenu, getTags} from '../../store/actions';
import { links } from '../../utils/constants';
import { validate } from '../../utils/constants';
import CheckboxElement from "../UI/Checkbox";
import { Scrollbars } from 'react-custom-scrollbars';

class Menu extends Component {

    state = {
        selectedMenu: '',
        isEditDialogOpen: false,
        isAddDialogOpen: false,
        isSousDialogOpen: false
    };

    componentDidMount() {
        const restaurantId = this.props.match.params.restId;
        this.props.getTags();
        this.props.getMenu(restaurantId);
    }

    onSubmitAddMenuHandler = menuHeading => {
       const data = {
           restaurant: parseInt(this.props.match.params.restId),
           name_en: menuHeading.menu_heading_en,
           name_ar: menuHeading.menu_heading_ar
       };
        this.props.addMenu(data).then(res => {
            this.props.getMenu(this.props.match.params.restId);
        });
        this.setState({isAddDialogOpen: false});
    };

    onSubmitEditMenuHandler = menuHeading => {
        const data = {
            restaurant: parseInt(this.props.match.params.restId),
            name_en: menuHeading.menu_heading_en,
            name_ar: menuHeading.menu_heading_ar
        };

        this.props.editMenu(this.state.selectedMenu.id, data).then(res => {
            this.props.getMenu(this.props.match.params.restId);
        });
        this.setState({isEditDialogOpen: false});
    };

    // onSubmitAddListItemHandler = values => {
    //     const tags = values.tags ? Object.keys(values.tags).filter(id => values.tags[id]).map(tag => parseInt(tag, 10)): null;
    //     if (!tags || tags.length === 0){
    //         this.setState({ add_tagsRequiredError: true });
    //         return;
    //     }
    //     const data = {
    //         tags,
    //         menu: +this.props.match.params.menuId,
    //         name_en: values.list_heading_en,
    //         name_ar: values.list_heading_ar,
    //     };
    //     this.props.addListItem(data).then(res => {
    //         this.props.getListItems(+this.props.match.params.menuId);
    //         this.setState({ isDialogOpen: false, add_tagsRequiredError: false });
    //     })
    // };
    onSubmitAddMenuHandler = menuHeading => {
        const tags = menuHeading.tags ? Object.keys(menuHeading.tags).filter(id => menuHeading.tags[id]).map(tag => parseInt(tag, 10)): null;
        if (!tags || tags.length === 0){
            this.setState({ add_tagsRequiredError: true });
            return;
        }
        const data = {
            tags,
            restaurant: parseInt(this.props.match.params.restId),
            name_en: menuHeading.menu_heading_en,
            name_ar: menuHeading.menu_heading_ar
        };
        this.props.addMenu(data).then(res => {
            this.props.getMenu(this.props.match.params.restId);
        });
        this.setState({isAddDialogOpen: false});
    };

    getTagStatus = id => {
        return this.state.selectedMenu.tags.indexOf(+id) !== -1;
    };

    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9 text-left">
                                <h1 className="color-grey">Add New Menu</h1>
                            </div>
                            <div className="col-xs-3">
                                <Form onSubmit={ this.submitted }>
                                    { formApi => (
                                        <form onSubmit={formApi.submitForm} className="search">
                                            <TextFields type="text" hintText="Search"/>
                                            <button className="no-style search-btn pointer">
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <Breadcrumb from={[{link: '/customers', label: 'Customers Administration'},
                                     {link: `/customers/${this.props.match.params.id}/edit`, label: 'Edit Customer'}]} current="Add Menu"/>
                </div>
                <div className="container inner-padding box py-15">

                    <div className="box-body" /*pt-20*/>
                        {/*<div className="text-right pb-20">
                            <Link onClick={ () => this.setState({ isSideDishDialogOpen: true }) } to="#" className="flex-align-y font-sm w-800 mr-30">Side Dish</Link>
                            <Link onClick={ () => this.setState({ isSousDialogOpen: true }) } to="#" className="flex-align-y font-sm w-800 mr-30">Sauce</Link>
                            <Link onClick={ () => this.setState({ isSousDialogOpen: true }) } to="#" className="flex-align-y font-sm w-800">Toppings</Link>
                        </div>*/}
                        {/* START: Card Items Container */}
                        <ul className="card-items small">
                            {/* START: Add New Card */}
                            <li className="card add">
                                <button className="no-style" onClick={() => this.setState({ isAddDialogOpen: true })}>
                                    <i className="fa fa-plus"></i>
                                    <p>Add New Menu</p>
                                </button>
                            </li>
                            {/* END: Add New Card */}

                            {/* START: Single Card Item */}
                            {
                                this.props.menus ? this.props.menus.map(menu => {
                                    return (
                                        <li className="card" key={menu.id}>
                                            <div className="action">
                                                <button className="no-style pointer" onClick={ () => this.setState({ isEditDialogOpen: true, selectedMenu: menu }) }>
                                                    <i className="fa fa-pencil"></i>
                                                </button>
                                            </div>
                                            <div className="inner">
                                                <h2>{ menu.name_en }</h2>
                                            </div>
                                            <div className="options text-center">
                                                <Link to={ links.Item(this.props.match.params.id, this.props.match.params.restId, menu.id) } className="pointer">
                                                    <i className="fa fa-plus font-sm mr-5"></i>
                                                    Add Items
                                                </Link>
                                            </div>
                                        </li>
                                    );
                                }) : null
                            }
                            {/* END: Single Card Item */}
                        </ul>
                        {/* END: Card Items Container */}
                    </div>
                </div>

                {/* START: Add New Menu Heading */}
                {/*<Dialog open={this.state.isAddDialogOpen} handleClose={ () => this.setState({ isAddDialogOpen: false }) }>*/}
                    {/*<Form onSubmit={ this.onSubmitAddMenuHandler }>*/}
                        {/*{ formApi => (*/}
                            {/*<form onSubmit={formApi.submitForm}>*/}
                                {/*<div className="popup-title">*/}
                                    {/*<h2>Add menu</h2>*/}
                                {/*</div>*/}
                                {/*<div className="popup-body">*/}
                                    {/*<InputTabs label="Menu heading"*/}
                                               {/*validations={ [...validate.$required] }*/}
                                               {/*formApi={formApi}*/}
                                               {/*field="menu_heading"*/}
                                               {/*value="menu_heading" />*/}
                                {/*</div>*/}
                                {/*<div className="popup-meta flex justify-end">*/}
                                    {/*<button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isAddDialogOpen: false }) }>Cancel</button>*/}
                                    {/*<button type="submit" className="btn filled primary min-120">Save</button>*/}
                                {/*</div>*/}
                            {/*</form>*/}
                        {/*)}*/}
                    {/*</Form>*/}
                    {/*<button className="no-style close-btn" onClick={ () => this.setState({ isAddDialogOpen: false }) }>×</button>*/}
                {/*</Dialog>*/}
                {/* END: Add New Menu Heading */}

                {/* START: Edit New Menu Heading */}
                {/*<Dialog open={this.state.isEditDialogOpen} handleClose={ () => this.setState({ isEditDialogOpen: false }) }>*/}
                    {/*<Form onSubmit={ this.onSubmitEditMenuHandler }>*/}
                        {/*{ formApi => (*/}
                            {/*<form onSubmit={ formApi.submitForm }>*/}
                                {/*<div className="popup-title">*/}
                                    {/*<h2>Edit menu</h2>*/}
                                {/*</div>*/}
                                {/*<div className="popup-body">*/}
                                    {/*<InputTabs label="Menu heading"*/}
                                               {/*validations={ [...validate.$required] }*/}
                                               {/*formApi={formApi}*/}
                                               {/*field="menu_heading"*/}
                                               {/*value="menu_heading" defaultValue={this.state.selectedMenu.name_en}/>*/}

                                {/*</div>*/}
                                {/*<div className="popup-meta flex justify-end">*/}
                                    {/*<button type="text" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isEditDialogOpen: false }) }>Cancel</button>*/}
                                    {/*<button type="submit" className="btn filled primary min-120">Save</button>*/}
                                {/*</div>*/}
                            {/*</form>*/}
                        {/*)}*/}
                    {/*</Form>*/}
                    {/*<button className="no-style close-btn" onClick={ () => this.setState({ isEditDialogOpen: false }) }>×</button>*/}
                {/*</Dialog>*/}
                {/* END: Edit New Menu Heading */}


                {/* START: Add List Popup */}
                <Dialog open={this.state.isAddDialogOpen}
                        handleClose={ () => this.setState({ isAddDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitAddMenuHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Add List</h2>
                                </div>
                                <div className="popup-body">
                                    <InputTabs label="Menu heading"
                                               validations={ [...validate.$required] }
                                               formApi={formApi}
                                               field="menu_heading"
                                               value="menu_heading" />
                                    <ul>
                                        {
                                            this.props.tags ? this.props.tags.map(tag => {
                                                return (
                                                    <li className="my-10" key={tag.id}>
                                                        <CheckboxElement formApi={formApi} field={'tags.' + tag.id} label={ tag.name }/>
                                                    </li>
                                                );
                                            }) : null
                                        }
                                    </ul>
                                    { formApi.errors && formApi.errors.tags && Object.keys(formApi.errors.tags).length === this.props.tags.length ? <span className="error-msg">You should choose at least one of the tags </span>: null }
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isAddDialogOpen: false }) }>Cancel</button>
                                    <button type="submit" className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isAddDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Add List Popup */}

                {/* START: Edit List Popup */}
                <Dialog open={this.state.isEditDialogOpen} handleClose={ () => this.setState({ isEditDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitEditListItemHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Edit Menu</h2>
                                </div>
                                <div className="popup-body">
                                    <InputTabs label="Menu heading"
                                               formApi={formApi}
                                               validations={ [...validate.$required] }
                                               field="menu_heading"
                                               value="menu_heading" defaultValue={this.state.selectedMenu.name_en} />
                                    <ul>
                                        {
                                            this.props.tags ? this.props.tags.map(tag => {
                                                return (
                                                    <li className="my-10" key={tag.id}>
                                                        <CheckboxElement formApi={formApi}
                                                                         defaultValue={ this.getTagStatus(tag.id) }
                                                                         field={'tags.' + tag.id}
                                                                         label={ tag.name } />

                                                    </li>
                                                );
                                            }) : null
                                        }
                                    </ul>
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isEditDialogOpen: false }) }>Cancel</button>
                                    <button type="submit" className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isEditDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Edit List Popup */}

                <Dialog open={this.state.isSideDishDialogOpen} handleClose={ () => this.setState({ isSousDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitEditListItemHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Side Dish</h2>
                                </div>
                                <div className="popup-body">
                                    <div className="row align-end">
                                        <div className="col-xs-5">
                                            <TextFields formApi={formApi}
                                                        type="text" label="Side Dish Name"
                                                        field="" />
                                        </div>
                                        <div className="col-xs-5">
                                            <TextFields formApi={formApi}
                                                        type="number" label="Side Dish price"
                                                        field="" />
                                        </div>
                                        <div className="col-xs-2 pb-5">
                                            <button className="no-style pointer">
                                                <i className="fa fa-plus-circle font-xl"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <ul className="tags with-close mt-20">
                                        <li><span className="ellipsis">Kechup</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                    </ul>
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isSideDishDialogOpen: false }) }>Cancel</button>
                                    <button type="submit" className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isSideDishDialogOpen: false }) }>×</button>
                </Dialog>


            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        menus: state.customer.menu,
        tags: state.customer.tags
    }
};


const mapDispatchToProps = dispatch => {
    return {
        addMenu: (data) => dispatch( addMenu(data) ),
        editMenu: (id, data) => dispatch( editMenu(id, data) ),
        getMenu: restaurantId => dispatch( getMenu(restaurantId) ),
        getTags: () => dispatch( getTags() ),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( Menu );




// WEBPACK FOOTER //
// ./src/components/Customer-administrator/Menu.js